import KebabMenuIcon from './KebabMenuIcon'

export default KebabMenuIcon
